import { Box, Link } from '@mui/material'
import { StyledEngineProvider } from '@mui/material/styles'
import { navigate } from '@reach/router'
import { t } from 'i18next'

import { PageErrorStyles as styles } from 'src/components/shared/PageError/PageErrorStyles'
import { AVISOS_LEXNET } from 'src/constants/routes'

import error from 'src/images/Error.png'
import ThemeProvider from 'src/providers/ThemeProvider'

import ButtonPrimary from '../ui/ButtonPrimary'
import { CallIcon, MailIcon } from '../ui/Icons'

export default function PageError(): JSX.Element {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider>
        <Box display="flex" flexDirection="column" sx={styles.wrapper}>
          <Box flex="0 0 auto" sx={styles.header}>
            <img
              src="https://assets.lefebvre.es/media/logos-2/png/lefebvre-205x56.png"
              alt="Lefebvre"
              width="139"
            />
          </Box>
          <Box flex="1 1 auto" sx={styles.content}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              sx={styles.contentElements}
            >
              <img src={error} alt="Lefebvre" width="160" />

              <Box sx={styles.mainText}>
                <strong>{t('views.pageError.main_text_1')}</strong>
                <span>{t('views.pageError.main_text_2')}</span>
              </Box>

              <Box sx={styles.secundaryText}>{t('views.pageError.secundary_text')}</Box>

              <Box sx={styles.button}>
                <ButtonPrimary
                  onClick={() => {
                    navigate(AVISOS_LEXNET())
                  }}
                >
                  {t('views.pageError.retry')}
                </ButtonPrimary>
              </Box>

              <Box sx={styles.info}>
                <Box sx={styles.infoText}>{t('views.pageError.help')}</Box>

                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={styles.infoWrapperNumber}
                >
                  <CallIcon sx={styles.infoIcon} />
                  <Link
                    sx={styles.infoNumber}
                    href={`tel:${t('views.help.telephone_1').replaceAll(' ', '')}`}
                    target="_blank"
                  >
                    {t('views.help.telephone_1')}
                  </Link>
                  {'  -  '}
                  <Link
                    sx={styles.infoNumber}
                    href={`tel:${t('views.help.telephone_2').replaceAll(' ', '')}`}
                    target="_blank"
                  >
                    {t('views.help.telephone_2')}
                  </Link>
                </Box>

                <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
                  <MailIcon sx={styles.infoIcon} />
                  <Link
                    href={`mailto:${t('views.help.email')}`}
                    target="_blank"
                    sx={styles.infoMail}
                  >
                    {t('views.help.email')}
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
